import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function UrgencySection() {
  return <section className="py-24 px-4 bg-dark" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-3xl bg-darkCard p-8 md:p-12 text-center overflow-hidden border border-red-500/20" data-id="element-106">
          <div className="absolute inset-0 border-2 border-red-500/20 rounded-3xl animate-pulse-slow pointer-events-none" data-id="element-107" />

          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 mb-6" data-id="element-108">
            <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-109" />
          </div>

          <h2 className="font-display text-2xl md:text-4xl font-bold mb-4 text-white" data-id="element-110">
            El grupo puede cerrarse en cualquier momento
          </h2>

          <p className="text-lg text-gray-300 mb-10 max-w-xl mx-auto font-medium" data-id="element-111">
            No te quedes afuera. Entrá ahora, asegurá tu lugar y enterate de los
            horarios antes de que se llenen los cupos.
          </p>

          <WhatsAppButton className="w-full md:w-auto" data-id="element-112">
            UNIRME AHORA GRATIS
          </WhatsAppButton>
        </motion.div>
      </div>
    </section>;
}